import { datadogRum } from '@datadog/browser-rum';
import { config } from '@base/constants';

const requiredEnvs = {
  applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
  clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  service: import.meta.env.VITE_DATADOG_SERVICE,
};

const canInit = Object.values(requiredEnvs).every((value) => value !== undefined);

const { appVersion: version, environment } = config;

if (canInit) {
  datadogRum.init({
    ...requiredEnvs,
    defaultPrivacyLevel: 'mask-user-input',
    sessionReplaySampleRate: 100,
    sessionSampleRate: 100,
    environment,
    version,
  });
}
